import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../views/Header';

const LoggedInHeaderLayout: React.FC = () => {
  return (
    <div className="flex flex-col h-screen">
      <Header />
      <main className="flex-grow overflow-auto bg-zinc-50">
        <Outlet />
      </main>
      {/* <footer className="flex-shrink-0 bg-gray-100 py-1">
        <div className="container mx-auto text-center">
          <p className="text-gray-600">© 2024 Arrow Agents</p>
        </div>
      </footer> */}
    </div>
  );
};

export default LoggedInHeaderLayout;